import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useMemo } from 'react';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import CanonicalLink from 'ecosystem-marketplace-core/components/elements/CanonicalLink';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import MetaDescription from 'ecosystem-marketplace-core/components/elements/MetaDescription';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady'; // @ts-expect-error untyped dependency

import { getPublicDetailPageFullUrl } from '../../../utils/urls';
import { PublicAppContext } from '../../../selectors/app';
import ThemeDetailsSocialSharing from './ThemeDetailsSocialSharing';
import ThemeDetailsStructuredData from './ThemeDetailsStructuredData';

function ThemeDetailsDocumentHead({
  ready,
  themeDetails
}) {
  const {
    name,
    offering: {
      installsCount,
      slug
    },
    provider: {
      name: providerName
    },
    pricing: {
      cents
    },
    reviewSummary: {
      overallRating,
      reviewCount
    },
    thumbnailUrl,
    versionPublishedAt
  } = themeDetails;
  const lang = getLang();
  const canonicalUrl = useMemo(() => getPublicDetailPageFullUrl(lang, slug), [lang, slug]);
  const documentTitle = I18n.text('marketplace-assets-ui.themes.details.documentTitle', {
    name,
    providerName
  });
  const metaDescription = unescapedText('marketplace-assets-ui.themes.details.metaDescription', {
    installsCount,
    name,
    providerName
  });
  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(PublicAppContext, {
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(CanonicalLink, {
          href: canonicalUrl
        }), /*#__PURE__*/_jsx(MetaDescription, {
          content: metaDescription
        }), /*#__PURE__*/_jsx(PrerenderReady, {
          ready: ready
        }), /*#__PURE__*/_jsx(ThemeDetailsSocialSharing, {
          canonicalUrl: canonicalUrl,
          description: metaDescription,
          title: documentTitle
        }), /*#__PURE__*/_jsx(ThemeDetailsStructuredData, {
          canonicalUrl: canonicalUrl,
          cents: cents,
          metaDescription: metaDescription,
          name: name,
          overallRating: overallRating,
          providerName: providerName,
          reviewCount: reviewCount,
          thumbnailUrl: thumbnailUrl,
          versionPublishedAt: versionPublishedAt
        })]
      })
    })
  });
}

export default ThemeDetailsDocumentHead;